// extracted by mini-css-extract-plugin
export default {"menu":"UserMenu_menu__BXGBz","name":"UserMenu_name__hnMNq","adminSettingsIcon":"UserMenu_adminSettingsIcon__cFStW","adminSettingsText":"UserMenu_adminSettingsText__n5Snq"};